import React, { useState } from 'react'
import ModalWindow from '../../../../common/components/organisme/ModalWindow/ModalWindow'
import { JWayIcon } from '../../../../common/assets/JWayIcons';
import Button from '../../../../common/components/atom/Button/Button';

export default function AddThumbnailBtnModal({children, contentRender}:{children?: React.ReactNode, contentRender? :(params: { closeModal: () => void }) => JSX.Element}) {
    const [isOpen, setIsOpen] = useState(false);
    const onClick = () => {
        setIsOpen(true);
    }
    const closeModal = () => {
        setIsOpen(false);
    }


  return (
    <>
        <Button onClick={onClick} variant="tertiary"><JWayIcon type="edit-sheet" size={15} color={'#606060'}/></Button>
        <ModalWindow  minHeight={400} isOpen={isOpen} setIsOpen={setIsOpen}> {children} {contentRender && contentRender({closeModal})} </ModalWindow>
    </>
  )
}
